import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import Icon from '../Icon';
import { ScrollElementToTarget } from '../../util/WindowHelper';
import { Link } from 'react-router';
import i18n from '../../../src/i18n/translate';
import { dataAttribsForEl } from '../../Util';

export default class ActionDropdown extends Component {
  static propTypes = {
    row: PropTypes.object.isRequired,
    menuItems: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        type: PropTypes.string.isRequired,
        actionType: PropTypes.string.isRequired,
        dataAttributes: PropTypes.object,
        disabled: PropTypes.bool,
        action: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
          .isRequired,
        hide: PropTypes.bool
      })
    ).isRequired,
    className: PropTypes.string,
    onToggle: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.scrollToView = this.scrollToView.bind(this);
  }

  renderMenuItem(item, index, row) {
    const className = item.disabled ? 'disabled' : '';
    const dataAttributes = dataAttribsForEl({ ...item.dataAttributes, id: row.id }, item.optionalAttributes);
    const content = (
      <>
        {item.icon && <Icon iconType={item.icon} />}
        {i18n.t(` ${item.title}`)}
      </>
    );

    if (item.actionType === 'link') {
      return (
        <MenuItem eventKey={index} {...dataAttributes} >
          <Link to={item.action} className={className}>
            {content}
          </Link>
        </MenuItem>
      );
    } else if (item.actionType === 'externalLink') {
      return (
        <MenuItem eventKey={index} {...dataAttributes} >
          <a href={item.action} className={className}>
            {content}
          </a>
        </MenuItem>
      );
    } else if (item.actionType === 'callToAction') {
      return (
        <MenuItem onClick={e => item.action(e, row)} eventKey={index} {...dataAttributes} >
          {content}
        </MenuItem>
      );
    }
  }

  scrollToView(open, e) {
    e.preventDefault();
    let target = e.currentTarget.nextSibling;
    let el = window;
    if (open) {
      //setTimeout to make sure the open menu is rendered before scrolling it into view.
      setTimeout(() => ScrollElementToTarget(el, target, 155), 0);
    }
    if (typeof this.props.onToggle === 'function') {
      this.props.onToggle(e);
    }
  }

  render() {
    return (
      <Dropdown onToggle={(open, e) => this.scrollToView(open, e)} pullRight={true}>
        <div bsRole="toggle" className="btn btn-link">
          {i18n.t('Actions')} <Icon iconType="chevron-down" />
        </div>
        <Dropdown.Menu className={`super-colors ${this.props.className}`}>
          {this.props.menuItems.map((item, index) => {
            if (
              (this.props.row.can_edit === false && item.type === 'edit') ||
              (this.props.row.can_delete === false && item.type === 'delete') ||
              (item.hide)
            ) {
              return;
            } else {
              return this.renderMenuItem(item, index, this.props.row);
            }
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
